import React from "react";
import { Beaker, RefreshCw, ArrowRight } from "lucide-react";
const HowItWorksSection = () => {
  return <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">How LabSwapp Works</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-sm text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-reagent-light-blue mb-4">
              <Beaker className="h-8 w-8 text-reagent-blue" />
            </div>
            <h3 className="text-xl font-semibold mb-3">List Your Reagents</h3>
            <p className="text-gray-600">
              Upload details about reagents your lab no longer needs but could be useful to others.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-reagent-light-green mb-4">
              <RefreshCw className="h-8 w-8 text-reagent-green" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Request Swaps</h3>
            <p className="text-gray-600">Find reagents you need and request a swap using your credits or by offering your own reagents.

Each credit has a virtual value of 1 euro.</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-reagent-light-blue mb-4">
              <ArrowRight className="h-8 w-8 text-reagent-blue" />
            </div>
            <h3 className="text-xl font-semibold mb-3">Complete the Exchange</h3>
            <p className="text-gray-600">
              Communicate with the other lab, arrange shipping, and complete the swap to earn more credits.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default HowItWorksSection;